import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '../../../../App/Hooks/reduxHooks'
import { IActivity } from '../../../../App/store/features/activity/interface/IActivityList'
import { stringToHsl } from '../../../../App/Util/stringToHsl'
import { IMenuCategory } from '../../../../LegacyCalendar/WaitingList/interface/IMenuCategory'
import {
  FormBackButton,
  FormBackButtonIcon,
  FormBackButtonText,
  FormHeader,
  FormListItem,
  FormListItemGraphic,
  FormListItemText,
  FormUnOrderedList,
} from '../../FormSwitch/styles'
import { activityToAddedActivity } from '../utils/activityToAppointmentActivity'

import { IAddedActivity } from './IAddActivity'
import { ISharedProps } from './IProps'

interface IProps extends ISharedProps {
  isMenuViewOpen: boolean
  closeMenuView: (closeView: undefined) => void
}

export const MenuView: FunctionComponent<IProps> = ({
  closeMenuView,
  isMenuViewOpen,
  setSelectedActivityArray,
  selectedActivityArray,
  defaultPersonUuids,
  activityList,
  personList,
}) => {
  const { menuList } = useAppSelector(state => ({
    menuList: state.menu.menu,
  }))
  const [breadcrumbs, setBreadcrumbs] = useState<number[]>([])
  const [selectedMenuCategoriesMenu, setSelectedCategoriesMenu] = useState<
    IMenuCategory[] | undefined
  >(menuList)

  const { t } = useTranslation()

  useEffect(() => {
    if (!menuList) {
      return
    }

    let categories = menuList
    for (const i of breadcrumbs) {
      const foundCategory = categories.find(
        category => category.id === breadcrumbs[i],
      )
      if (!foundCategory) {
        break
      }

      if (!foundCategory.categories) {
        if (foundCategory.activities) {
          const foundActivities: IActivity[] = foundCategory.activities
          const mappedActivities: IAddedActivity[] = foundActivities.map(
            activity =>
              activityToAddedActivity(
                activity,
                activityList,
                defaultPersonUuids,
                personList,
              ),
          )
          setSelectedActivityArray({
            data: [...selectedActivityArray, ...mappedActivities],
            actionType: 'add',
          })
          closeMenuView(undefined)
        }
      } else {
        categories = foundCategory.categories
      }
    }
    setSelectedCategoriesMenu(categories)
  }, [
    activityList,
    breadcrumbs,
    closeMenuView,
    defaultPersonUuids,
    menuList,
    personList,
    selectedActivityArray,
    setSelectedActivityArray,
  ])

  if (!isMenuViewOpen) {
    return null
  }
  if (!menuList || !selectedMenuCategoriesMenu) {
    return null
  }

  const onMenuClicked = (menuId: number) => {
    setBreadcrumbs([...breadcrumbs, menuId])
  }

  const menuBackButtonClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    const newBreadcrumbs = [...breadcrumbs]
    newBreadcrumbs.splice(-1)
    setBreadcrumbs(newBreadcrumbs)
    if (breadcrumbs.length === 0) {
      closeMenuView(undefined)
    }
  }

  return (
    <>
      <FormHeader>{t('Add menu')}</FormHeader>
      <FormBackButton onClick={e => menuBackButtonClicked(e)}>
        <FormBackButtonIcon icon="chevron-left" />
        <FormBackButtonText>{t('Back')}</FormBackButtonText>
      </FormBackButton>

      <FormUnOrderedList>
        {selectedMenuCategoriesMenu.map(menu => (
          <FormListItem key={menu.id} onClick={() => onMenuClicked(menu.id)}>
            <FormListItemGraphic color={stringToHsl(menu.name, 50, 50)} />
            <FormListItemText>{menu.name}</FormListItemText>
          </FormListItem>
        ))}
      </FormUnOrderedList>
    </>
  )
}
